<template>
  <div id="app">
    <router-view />
    <!-- 显示当前路由匹配的组件 -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app,
body,
html {
  margin: 0;
  padding: 0;
}
</style>
